import makeCall from '../../../helpers/caller';
import { validateEmail } from '../../../helpers/validators';

// ------------------------------------
// Constants
// ------------------------------------

export const UPDATE_FIELD_FP = 'UPDATE_FIELD_FP';
export const SET_ERRORS_FP = 'SET_ERRORS_FP';
export const EMAIL_SENT_SUCCESS = 'EMAIL_SENT_SUCCESS';
export const RESET_STATE = 'RESET_STATE';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';

// ------------------------------------

export const updateFieldFP = (key, e) => ({
  key,
  type: UPDATE_FIELD_FP,
  value: e.target.value,
});

export const setErrorsFP = (errors) => ({
  errors,
  type: SET_ERRORS_FP,
});

export const emailSentSuccess = () => ({
  type: EMAIL_SENT_SUCCESS,
});

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});

export const resetState = () => ({
  type: RESET_STATE,
});

export const submitForm = () => (dispatch, getState) => {
  const errors: { email_valid: boolean; show_error?: boolean } = {
    email_valid: false,
  };
  if (validateEmail(getState().forgot_password.email)) {
    errors.email_valid = true;
    errors.show_error = false;
  }

  if (errors.email_valid) {
    dispatch(toggleLoading());
    return makeCall({
      call: {
        job: 'forgotPassword',
        section: 'auth',
      },
      payload: {
        platformKey: '1efdfeb8-a14a-4eac-b66d-6c4929e4376c',
        username: getState().forgot_password.email,
        srcHost: window.location.hostname,
        srcPath: window.location.pathname,
      },
    })
      .then((_data) => {
        dispatch(emailSentSuccess());
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        dispatch(toggleLoading());
        dispatch(
          setErrorsFP({
            email_valid: true,
            error_message: error.message || 'Something went wrong',
            show_error: true,
          })
        );
      });
  }
  dispatch(setErrorsFP(errors));
};

const initialState = {
  email: null,
  email_sent: false,
  email_valid: true,
  error_message: '',
  loading: false,
  show_error: false,
};

const forgotPassword = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_FIELD_FP': {
      return {
        ...state,
        [action.key]: action.value,
      };
    }
    case 'SET_ERRORS_FP': {
      return {
        ...state,
        email_valid: action.errors.email_valid,
        error_message: action.errors.error_message,
        show_error: action.errors.show_error,
      };
    }
    case 'EMAIL_SENT_SUCCESS': {
      return {
        ...state,
        email_sent: true,
      };
    }
    case 'RESET_STATE': {
      return {
        email: null,
        email_sent: false,
        email_valid: true,
        show_error: false,
      };
    }
    case 'TOGGLE_LOADING': {
      return {
        ...state,
        loading: !state.loading,
      };
    }
    default: {
      return state;
    }
  }
};

export default forgotPassword;
